import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import Edition from "../Components/Edition/Edition";
import { make_request } from "../Utils/Utils";
class Editions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editions: [],
    };
  }

  fetch_request = async () => {
    let responseJson = null;
    responseJson = await make_request({
      path: "editions",
      method: "GET",
    });

    if (responseJson && responseJson.status === "success") {
      this.setState({
        editions: responseJson["editions"],
      });
    }
  };

  async componentDidMount() {
    this.fetch_request();
  }

  render() {
    return (
      <div className="welcome innerBody">
        {!this.props.noHeader && <Header />}

        <div className="container">
            { !this.props.noTitle &&
              <div className="row pb-4">
                <div className="text-center">
                  <h3 className="pb-3 text-center"> OUR EDITIONS </h3>
                  <p className="col-xl-8 col-sm-12 offset-xl-2 text-center">
                    We will launch a new Puzzled edition every 2 months. Once we have
                    100 people in our Hall of Fame, we mark the edition as complete.
                    The completed editions will be open to access and can be played anytime.
                    Currently running editions is where the fun is, and will be a race to the top. 
                  </p>
                </div>
              </div>
            }
            <div className="row editions">
              {this.state.editions &&
                this.state.editions.map((edition) => (
                  <Edition
                    key={edition.id}
                    id={edition.id}
                    name={edition.name}
                    number={edition.number}
                    description={edition.description}
                    completed={edition.completed}
                    completed_at={edition.completed_at}
                    image={edition.image}
                    status={edition.status}
                    puzzlers={edition.puzzlers}
                    rank={edition.rank}
                    total_levels={edition.levels}
                    current_level={edition.current_level}
                  />
                ))}
            </div>
          </div>
        {!this.props.noFooter && <Footer />}
      </div>
    );
  }
}
export default Editions;
